import SendToGraphDataType from "Areas/Documents/content/types/sendToGraphDataType";
import buildContextMenuItems from "./buildContextMenuItems";
export default (documentId, documentObjects, nodeSource, contextMenuRef, imageComponentRef, onPhotoSendToGraph, onTextSendToGraph) => (e) => {
    var _a, _b;
    if (!documentId ||
        !documentObjects ||
        !contextMenuRef ||
        !((_a = contextMenuRef.current) === null || _a === void 0 ? void 0 : _a.show) ||
        !((_b = contextMenuRef.current) === null || _b === void 0 ? void 0 : _b.setMenuItems)) {
        return;
    }
    const selectionData = window.getSelection();
    if (!selectionData && !imageComponentRef) {
        return;
    }
    let data;
    if ((imageComponentRef === null || imageComponentRef === void 0 ? void 0 : imageComponentRef.current) && e.target === imageComponentRef.current) {
        data = {
            type: SendToGraphDataType.PHOTO,
            data: imageComponentRef.current.src
        };
    }
    else if (selectionData && selectionData.toString() && !selectionData.isCollapsed) {
        data = {
            type: SendToGraphDataType.TEXT,
            data: selectionData.toString()
        };
    }
    const menuItems = data &&
        buildContextMenuItems(data, onPhotoSendToGraph
            ? (url) => {
                documentId &&
                    documentObjects &&
                    onPhotoSendToGraph &&
                    onPhotoSendToGraph(documentId, url, documentObjects, nodeSource === null || nodeSource === void 0 ? void 0 : nodeSource.NodeId, (nodeSource === null || nodeSource === void 0 ? void 0 : nodeSource.GroupId) || undefined);
            }
            : undefined, onTextSendToGraph
            ? (text) => {
                documentId &&
                    documentObjects &&
                    onTextSendToGraph &&
                    onTextSendToGraph(documentId, text, documentObjects, nodeSource === null || nodeSource === void 0 ? void 0 : nodeSource.NodeId, (nodeSource === null || nodeSource === void 0 ? void 0 : nodeSource.GroupId) || undefined);
            }
            : undefined);
    if (menuItems && menuItems.length) {
        contextMenuRef.current.setMenuItems(menuItems);
        contextMenuRef.current.show(e.clientX, e.clientY);
    }
};
